import React, { useContext, useState } from 'react';
import Table from '../Table';
import { Button, OverlayTrigger, Tooltip, ProgressBar, Badge } from 'react-bootstrap';
import Confirmation from '../ui/Confirmation';
import { TblHIpv4, headTbl } from '../../data/tables';
import { useGetDta } from '../../hooks/useGetDta';
import ModIpv4 from './ModIpv4';
import LoadinSpin from '../ui/LoadinSpin';
import DropDownsCol from '../ui/DropDownsCol';
import { useShowColums, useShowColumsHook } from '../../hooks/useShowColums';
import { getInitialColumns } from '../../data/cards';

const TblRedes = ({ allows }) => {
    const { loading, data, getInfo } = useGetDta(`networks/redsipv4`);

    const initialColums = getInitialColumns('redsipv4', TblHIpv4);
    const { toggleCheck, columnasVisibles } = useShowColumsHook(initialColums, 'redsipv4');

    const { ipv4_add, ipv4_edit, ipv4_del } = allows;

    const [show, setShow] = useState(false);
    const [showd, setShowd] = useState(false);
    const [item, setItem] = useState();
    const [info, setInfo] = useState({});
    const porcentA = (total, us) => {
        const t = parseInt(total);
        const u = parseInt(us);
        const porcent = (u / t) * 100;
        return porcent.toFixed(1);
    };
    const porcetColor = (por) => {
        if (por < 50) return 'primary';
        if (por > 50 && por < 80) return 'warning';
        if (por > 80) return 'danger';
    };
    const openEdit = (ol) => {
        setItem(ol);
        setShow(true);
    };
    const StatusColumn = ({ row }) => {
        return (
            <>
                <ProgressBar
                    now={porcentA(row.original.host, row.original.used)}
                    variant={porcetColor(porcentA(row.original.host, row.original.used))}
                    visuallyHidden
                />
                <span style={{ fontSize: '11px' }}>
                    {porcentA(row.original.host, row.original.used)}
                    {' % '}
                    {'('}
                    {row.original.used}-{row.original.host} {')'}
                </span>
            </>
        );
    };
    const NODOColum = ({ row }) => {
        const olts = JSON.parse(row.original?.olts || '[]');

        return (
            <div>
                <strong>{row.original.namenodo}</strong>
                {olts.length ? (
                    <div>
                        <small>Olts</small>
                        {olts.map((olt, index) => (
                            <Badge color="primary" className="mx-1" key={index} style={{ display: 'inline-block' }}>
                                {olt.label}
                            </Badge>
                        ))}
                    </div>
                ) : null}
            </div>
        );
    };

    if (loading) return <LoadinSpin />;

    const ActionColumn = ({ row }) => {
        return (
            <>
                <>
                    {ipv4_edit && (
                        <OverlayTrigger
                            className="action-icon "
                            placement="left"
                            overlay={<Tooltip id="overlay-example"> Editar</Tooltip>}>
                            <i className="mdi mdi-pencil mdi-18px " onClick={() => openEdit(row.original)}></i>
                        </OverlayTrigger>
                    )}

                    {ipv4_del && (
                        <OverlayTrigger
                            placement="left"
                            overlay={
                                <Tooltip id="overlay-example">
                                    {row.original.used === 0 ? 'Borrar' : 'No se puede eliminar- Clientes conectados'}{' '}
                                </Tooltip>
                            }>
                            {row.original.used === 0 ? (
                                <i className="mdi mdi-delete mdi-18px " onClick={() => dele(row.original.id)}></i>
                            ) : (
                                <i className="mdi mdi-delete-off mdi-18px text-danger "></i>
                            )}
                        </OverlayTrigger>
                    )}
                </>
            </>
        );
    };
    const columns = [
        {
            Header: 'Id',
            accessor: 'id',
            sort: true,
        },
        {
            Header: 'Nombre',
            accessor: 'nombre',
            sort: true,
        },
        {
            Header: 'Red',
            accessor: 'red',
            sort: true,
        },
        {
            Header: 'Uso IPS',
            accessor: 'used',
            sort: true,
            Cell: StatusColumn,
        },
        {
            Header: 'CIDR',
            accessor: 'cidr',
            sort: true,
        },
        {
            Header: 'Router',
            accessor: 'namenodo',
            sort: true,
            Cell: NODOColum,
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    const dele = (id) => {
        setInfo({ id, type: 'RED' });
        setShowd(true);
    };
    return (
        <div>
            {' '}
            <h4 className="header-title mb-2">Redes Ipv4</h4>
            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
                columnasVisibles={columnasVisibles}
                searchBoxClass="mb-2"
                customButton={
                    ipv4_add && (
                        <Button type="button" onClick={() => openEdit({})}>
                            <b>+</b> Nuevo
                        </Button>
                    )
                }
                visiblesCustum={
                    <DropDownsCol
                        cols={columnasVisibles} // Pasar el estado desde TblZonas
                        toggleCheck={toggleCheck} // Pasar la función de toggleCheck desde TblZonas
                    />
                }
            />
            <ModIpv4 show={show} callBk={getInfo} onClose={() => setShow(false)} ipv4={item} />
            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />
        </div>
    );
};

export default TblRedes;
